module.exports = __webpack_public_path__ + "img/the-netherlands-mental-and-behavioural-disorders-male.6d63b8f5.png";